import { getAxiosInstance } from '../blocks/axios/axiosFactory';

const url = "/fleet";

export default class FleetService {
    static GetTrafficAreasGeography() {
        return getAxiosInstance().get(`${url}/getTrafficAreasGeography`);
    }
}
